import * as React from 'react';
import { Activity, UserToken } from "../../../amorg-common";
import { useEffect } from 'react';
import { PublicAmorgUser } from '../../../amorg-common';
import { ActivityComponentProps } from './ActivityComponentProps';
import { getActivity } from '../../../api/activityClientApi';
import { getUsers } from '../../../api/userClientApi';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { ActivityHeader } from './ActivityHeader';
import { AgendaItemListPanel } from './AgendaItemListPanel';
import { MeetingDetailsPanel } from './MeetingDetailsPanel';
import { getAuthorizedActiveUserOrRedirect } from '../../../api/serverApiHelpers';

type MeetingActivityPageViewProps = {
    activityId:string
}

type State = 
    { state:'initial-loading' } |
    { state:'ready', activity:Activity, activeUser:UserToken, users:PublicAmorgUser[], loading: boolean } |
    { state:'error', errorMessage:string }

export default function MeetingActivityPageView(props:MeetingActivityPageViewProps): JSX.Element 
{
    const [state, setState] = React.useState<State>({ state:'initial-loading' });

    useEffect(() => {
        updateState();
    }, [props.activityId]);

    async function updateState()
    {
        if(state.state === 'ready') {
            setState({...state, loading:true});
        }

        const activity = await getActivity(props.activityId);
        if(!activity)
        {
            setState({state:'error', errorMessage:'Ugyldig url'});
            return;
        }

        if(activity.activityType !== 'WorkgroupMeeting' && activity.activityType !== 'AnnualWorkgroupStatus')
        {
            setState({state:'error', errorMessage:'Ugyldig aktivitetstype'});
            return;
        }
        
        const activeUser = await getAuthorizedActiveUserOrRedirect(['EditSurveys']);

        setState({
            state:'ready',
            activity,
            activeUser,
            users: await getUsers(),
            loading:false
        });
    }

    let componentProps: ActivityComponentProps | null = null;
    if(state.state === 'ready')
    {
        componentProps = {
            activeUser: state.activeUser,
            activity: state.activity as Activity,
            users: state.users,
            onActivityUpdated:updateState
        };
    }

    return (
        <>
            <LoadingPageOverlay loading={state.state === 'initial-loading' || (state.state === 'ready' && state.loading)} />

            {state.state === 'error' && <p>{state.errorMessage}</p>}

            {state.state === 'ready' && 
                <AgendaMeetingActivityView {...(componentProps as ActivityComponentProps)} />
            }
        </>
    );
}

function AgendaMeetingActivityView (props: ActivityComponentProps): JSX.Element 
{
    const [loading, setLoading] = React.useState(true);

    async function isLoading (value: boolean)
    {
        setLoading(value);
    }

    async function handleActivityUpdated ()
    {
        setLoading(true);
        props.onActivityUpdated();
        // setInvitationStatus(await getMeetingInvitationStatus(props.activity.id));
        setLoading(false);
    }

    return (
        <>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <ActivityHeader
                            activity={props.activity}
                            deleteConfirmationTextInModal="Tilhørende handlepunkter vil ligeledes blive slettet."
                            onActivityUpdated={handleActivityUpdated}
                            isLoading={isLoading} />

                        <MeetingDetailsPanel
                            activity={props.activity}
                            descriptionText="Mødebeskrivelse"
                            periodSelection='date-time'
                            onActivityUpdated={handleActivityUpdated}
                            componentTitle='Møde info'
                            users={props.users}
                            participantTexts={{ header: 'Deltagere' }}
                            infoComponents={
                                <>
                                    <LoadingPageOverlay loading={loading} />
                                </>
                            } />
                    
                        <AgendaItemListPanel
                            activityId={props.activity.id}
                            agendaItems={props.activity.agendaItems}
                            users={props.users}
                            onUpdated={handleActivityUpdated} />
                    </>
                } />
        </>
    );
}